import { render } from "./AttachmentList.vue?vue&type=template&id=6cadcde4&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"

import "./AttachmentList.vue?vue&type=style&index=0&id=6cadcde4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cadcde4"]])

export default __exports__